import imgTaiLee from "@assets/events-awards/dta/img-tai-lee.jpg";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Tai Lee Section on DTA Judges Page
 */
const TaiLeeSection = (): React.ReactElement => {
  return (
    <AccordionV2
      testId="tai-lee-section-component"
      className="rounded-tl-lg rounded-tr-lg border border-gray-175 bg-gray-150 py-4"
      headerChildren={
        <EventsAwardsAccordionHeader
          title="Professor Tai Lee Siang"
          className="tracking-normal"
        />
      }
      arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
      isArrowRight
    >
      <div className="mt-4 flex flex-col border-t border-gray-175 px-6 pt-4 md:flex-row">
        <div className="mb-6 h-auto w-8/12 pr-4 md:mb-2 md:w-2/12 md:pr-5">
          <img
            src={imgTaiLee}
            width={576}
            height={283}
            alt="professor-tai-lee-siang"
            className="object-contain"
          />
        </div>

        <div className="md:w-8/12 md:pl-1 md:pr-1">
          <p className="mb-0 font-bold">Professor Tai Lee Siang</p>

          <p className="mb-0 font-bold">
            Deputy President and Chief Innovation & Enterprise Officer
          </p>

          <p className="mb-0 font-bold">(Chairman of the judging panel)</p>

          <p className="font-bold">SUTD</p>

          <p>
            Professor Tai Lee Siang assumed the role of Deputy President/ Chief
            Innovation & Enterprise Officer (CIEO) of SUTD on 1 August 2024. He
            is concurrently the Head of the Architecture and Sustainable Design
            (ASD) Pillar – a role he has held since 2021.
          </p>

          <p>
            He also oversees the Design and Artificial Intelligence degree
            programme that is now seeing a profound impact in the fields of
            design. In 2022, he was appointed as Centre Director of DesignZ –
            the next generation design centre of SUTD.
          </p>

          <p>
            Prof Tai graduated with a Bachelor of Architecture (Honours) from
            NUS in 1987 and has been practising as an architect and urban
            designer since 1990. As a partner at DP Architects Pte Ltd, his
            projects won local and international awards, and he was featured in
            the Urban Redevelopment Authority’s ‘20 under 45’ young architects’
            exhibition in 2004.
          </p>

          <p>
            He served as President of the Singapore Institute of Architects from
            2007 to 2009 and became the first Chairman of the Design Alliance of
            Singapore in 2009. In 2013, he was elected President of the Design
            Business Chamber Singapore and launched the Singapore Good Design
            Mark in 2014. From 2010 to 2016, he was Group Managing Director of
            Ong&Ong Group, a multidisciplinary design firm.
          </p>

          <p>
            In 2011, Prof Tai was elected President of the Singapore Green
            Building Council and established Singapore’s first green building
            product certification scheme. He joined the World Green Building
            Council as a Board Director in 2013 and was elected Chairman in
            2016, initiating the global “Advancing Net Zero” campaign.
          </p>

          <p>
            After his tenure at the World Green Building Council, he joined the
            Building and Construction Authority (BCA) as Executive Director of
            BuildSG, leading a nearly 100-strong team and spearheading industry
            transformation.
          </p>
        </div>
      </div>
    </AccordionV2>
  );
};
export default TaiLeeSection;
